import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, Button } from 'react-bootstrap';
import photo4 from './images/4.webp';
import photo5 from './images/5.webp';
import photo6 from './images/6.webp';
import photo7 from './images/10.webp';
import photo8 from './images/9.webp';
import photo9 from './images/12.webp';
import photo10 from './images/13.webp';
import photo11 from './images/16.webp';
import photo12 from './images/15.webp';
import photo13 from './images/17.webp';
import photo14 from './images/18.webp';
import photo15 from './images/20.webp';

const products = [
  { id: 1, name: 'Jointace Tablet 300 mg', price: 350, image: photo9 },
  { id: 2, name: 'Evion 400mg Strip Of 20 Capsule', price: 150, image: photo5 },
  { id: 3, name: 'Fytika Omega1000mg Bottle Of 60 Softgel Capsules', price: 200, image: photo7 },
  { id: 4, name: 'Depura Vitamin D3 60k Sugar Free Oral Solution 5ml', price: 35, image: photo4 },
  { id: 5, name: 'Hashmi Hard Rock Boost Energy Capsule 20', price: 90, image: photo8 },
  { id: 6, name: 'Complan Viemax Chocolate Flavour Refill 200gm', price: 220, image: photo6 },
  { id: 7, name: 'Sunhalt Gold Spf 50 Tube Of 60gm Hydrating Sunscreen', price: 45, image: photo10 },
  { id: 8, name: 'Skinnable Sunscreen Gel Spf 50+ 50 Gm', price: 140, image: photo11 },
  { id: 9, name: 'Acne Uv Spf 50 Gel 50gm', price: 240, image: photo12 },
  { id: 10, name: 'Pharmeasy Digital Thermometer Flexi Tip', price: 350, image: photo13 },
  { id: 11, name: 'Dr. Morepen Gluco One Bg 03 Glucometer Test Strips Box Of 50', price: 120, image: photo14 },
  { id: 12, name: 'Contour Plus Glucometer Test Strips Box Of 50', price: 320, image: photo15 },
];

const WellnessDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <Container className="mt-5 text-center">
        <h3>Product not found</h3>
        <Button variant="secondary" onClick={() => navigate('/wellnesss')} className="mt-3">
          Back to Wellness
        </Button>
      </Container>
    );
  }

  const handleBuyNow = () => {
    navigate('/cart');
  };

  const handleAddToCart = () => {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existingItemIndex = cart.findIndex(item => item.id === product.id);

    if (existingItemIndex !== -1) {
      cart[existingItemIndex].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    localStorage.setItem('cart', JSON.stringify(cart));
    alert(`${product.name} added to cart!`);
  };

  return (
    <Container className="mt-5">
      <Card className="text-center">
        <Card.Img
          variant="top"
          src={product.image}
          alt={product.name}
          style={{ maxHeight: '400px', objectFit: 'contain' }}
        />
        <Card.Body>
          <Card.Title>{product.name}</Card.Title>
          <Card.Text><strong>Price:</strong> ₹{product.price}</Card.Text>
          <Button variant="success" onClick={handleBuyNow} className="me-2">
Go to Cart          </Button>
          <Button variant="warning" onClick={handleAddToCart} className="me-2">
            Add to Cart
          </Button>
          <Button variant="secondary" onClick={() => navigate('/wellness')}>
            Back to Wellness
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default WellnessDetail;
